shvenergy.footerpopup = (function ($) {
	"use strict";

	function init() {

		var footerPopups = $("[data-footerpopup]");

		footerPopups.each(function () {

			var popup = $(this);

			var button = popup.find(".footer-popup-button");
			var content = popup.find(".footer-popup-content");

			button.on("click", () => {
				var attr = button.attr("aria-expanded");
				button.attr("aria-expanded", attr === "false" ? "true" : "false").toggleClass("selected");
				content.toggle();
			});

		});


		function hide() {
			$(".footer-popup-content").hide();
			$(".footer-popup-button").attr("aria-expanded", "false").removeClass("selected");
		}

		$(document).on("keydown", function (event) {
			var key = event.keyCode || event.which;
			if (key === 27) {
				hide();
			}
		});

		$('body').on('click', function (e) {
			if ($(e.target).closest('[data-footerpopup]').length == 0) {
				hide();
			}
		});

	}

	init();

})(jQuery);